"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnFilterConfig = void 0;
const react_1 = require("react");
const table_columns_1 = require("../../../../../common/table-columns");
const table_filter_1 = require("../../../../../common/table-filter");
const useColumnFilterConfig = (productTreeNodeId) => {
    const getTextFilterColumnConfig = (0, table_filter_1.useTextColumnFilterSortConfig)();
    const getMultiSelectFilterColumnConfig = (0, table_filter_1.useMultiSelectColumnFilterSortConfig)(productTreeNodeId);
    const getColumnNumberFilterConfig = (0, table_filter_1.useNumberColumnFilterSortConfig)();
    const getColumnFilterConfig = (0, react_1.useCallback)((columnId) => {
        const { dataMeta: { isAIEnriched, isMeasure }, } = (0, table_columns_1.parseColumnId)(columnId);
        if (isMeasure) {
            return getColumnNumberFilterConfig({ id: columnId });
        }
        if (isAIEnriched) {
            return getMultiSelectFilterColumnConfig({ id: columnId });
        }
        return getTextFilterColumnConfig({ id: columnId });
    }, [getTextFilterColumnConfig, getColumnNumberFilterConfig, getMultiSelectFilterColumnConfig]);
    return getColumnFilterConfig;
};
exports.useColumnFilterConfig = useColumnFilterConfig;
